import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

export function GenericErrorWidget() {
  const intl = useIntl();

  return (
    <>
      <img className="block max-w-fit" src="/illustrations/ErrorGeneric.svg" alt="Something went wrong" />
      <div className="py-10">
        <div className="block-list space-y-8 text-left">
          <Typography variant="h2" style={{ fontSize: 26, fontWeight: 800 }}>
            {intl.formatMessage({ id: 'error.generic.header', defaultMessage: 'Something went wrong' })}{' '}
          </Typography>
          <Typography variant="body1">
            {intl.formatMessage({
              id: 'error.generic.refresh',
              defaultMessage: 'Please refresh the page or try again in a few minutes.',
            })}
          </Typography>
          <Typography variant="body1">
            {intl.formatMessage({
              id: 'error.generic.contact',
              defaultMessage: 'If the problem persists, please contact our support team',
            })}{' '}
            <a className="underline" href="mailto: Support@Tradebyte.com">
              Support@Tradebyte.com
            </a>
          </Typography>
        </div>
      </div>
    </>
  );
}
